import { Hero } from "../components/Hero";
import { Values } from "../components/Values";
import { Kids } from "../components/Kids";
import { Projects } from "../components/Projects";
import { Steps } from "../components/Steps";
import { Kit } from "../components/Kit";
import { Proof } from "../components/Proof";
import { Werkplaats } from "../components/Werkplaats";
import { About } from "../components/About";
import { FAQ } from "../components/FAQ";
import { CTA } from "../components/CTA";
import { WorkshopLocations } from "../components/WorkshopLocations";
import { Seo } from "../components/seo/Seo";

export function HomePage() {
  return (
    <>
      <Seo
        title="Makers Hub — Arduino & tech-workshops voor kinderen 10-12 in Vlaanderen"
        description="Zaterdagworkshops Arduino, programmeren en 3D printen voor kinderen 10-12 jaar in Vlaanderen. Echte hardware, kleine groepen (max 8), werkend project mee naar huis. Eerste edities open — €30 all-in (pilot-prijs)."
        path="/"
      />
      <Hero />
      <Values />
      <Kids />
      <Projects />
      <Steps />
      <Kit />
      <Proof />
      <Werkplaats />
      <About />
      <FAQ />
      <WorkshopLocations />
      <CTA />
    </>
  );
}
